<template>
  <div>

    <Header></Header>

    <div id="main">

      <Vitrine></Vitrine>

      <AboutSection></AboutSection>

      <StoresSection :stores="stores"></StoresSection>

      <ProjectsSection :projects="projects"></ProjectsSection>

      <NewsletterSection></NewsletterSection>

      <HowWorksSection></HowWorksSection>

      <TestimonySection></TestimonySection>

      <JoinSection></JoinSection>

      <MillestonesSection v-if="categories" :categories="categories"></MillestonesSection>

      <PartnersSection></PartnersSection>

      <ContactSection></ContactSection>

      <!-- <DownloadSection></DownloadSection> -->
      <transition name="fade">
        <div v-if="showScrollButton" id="scrollToTop">
          <a href="" @click.stop.prevent="scrollToTop()">
            <font-awesome-icon :icon="['fas', 'chevron-circle-up']" size="lg" />
          </a>
        </div>
      </transition>

    </div>

    <Footer></Footer>
    <Loading v-if="loading"></Loading>

    <div id="privacyPolicy" v-if="showPrivacyPolicyModal">
      <div class="background"></div>
      <span>Utilizamos tecnologias essenciais de acordo com a nossa <a href="/privacy-policy">Política de Privacidade</a> e, ao continuar navegando, você concorda com estas condições.</span>
      <button @click.stop.prevent="showPrivacyPolicyModal = false;">OK</button>
    </div>

    <div id="addToHomescreen" v-if="showAddToHomescreen" @click="showAddToHomescreen = false">
      <span>Adicione um atalho na sua tela inicial!<br/> Clique no ícone <img :src="shareIcon" /> e em seguida <b>Tela de Início</b></span>
    </div>

  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Vitrine from './home/Vitrine'
import AboutSection from './home/AboutSection'
import StoresSection from './home/StoresSection'
import MillestonesSection from './home/MillestonesSection'
import JoinSection from './home/JoinSection'
import ProjectsSection from './home/ProjectsSection'
import NewsletterSection from './home/NewsletterSection'
import ContactSection from './home/ContactSection'
import HowWorksSection from './home/HowWorksSection'
import DownloadSection from './home/DownloadSection'
import PartnersSection from './home/PartnersSection'
import TestimonySection from './home/TestimonySection'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faChevronCircleUp} from '@fortawesome/fontawesome-free-solid'
import Loading from './includes/Loading'
import { API } from '../services/api'
import shareIcon from "../assets/images/share-icon.png";

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    Vitrine,
    AboutSection,
    StoresSection,
    MillestonesSection,
    JoinSection,
    ProjectsSection,
    NewsletterSection,
    ContactSection,
    HowWorksSection,
    DownloadSection,
    PartnersSection,
    TestimonySection,
    FontAwesomeIcon,
    Loading
  },
  data () {
    return {
      loading: false,
      projects: null,
      stores: null,
      categories: null,
      showScrollButton: false,
      showAddToHomescreen: false,
      scrollPosition: 0,
      shareIcon: shareIcon,
      showPrivacyPolicyModal: true
    }
  },
  created(){
    this.loadStores();
    this.loadProjects();
  },
  mounted (){
    this.updateScroll()
    window.addEventListener('scroll', this.updateScroll)
    this.addToHomescreen();
  },
  methods: {
    addToHomescreen(){
      // Detecta se o dispositivo está no iOS
      const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test( userAgent );
      }
      // Detects if device is in standalone mode
      const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
      // Verifica se deve exibir notificação popup de instalação:

      if (isIos() && !isInStandaloneMode()) {
        this.showAddToHomescreen = true;
        var $this = this;
        setTimeout(function(){
            $this.showAddToHomescreen = false;
        }, 20000);
      }
    },
    loadProjects(){
      this.$http.get(API.Projects.projects).then((result) => {
        this.projects = result.body;
        this.projectsList = this.projects
        this.loadCategories();
      });
    },
    loadStores(){
      this.$http.get(API.Stores.list).then((result) => {
        this.stores = result.body;
      });
    },
    loadCategories(){
      this.$http.get(API.Projects.categories).then((result) => {
        // this.loading = false
        this.categories = result.body;
      });
    },
    updateScroll(){
      this.scrollPosition = window.scrollY;
      if(this.scrollPosition > 20){
        this.showScrollButton = true
      }else{
        this.showScrollButton = false
      }
    },
    scrollToTop(){
      this.$scrollTo('#main', 500);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#main{
  padding-top: 90px;
}
#scrollToTop{
  position: fixed;
  z-index: 100;
  bottom: 30px;
  right: 20px;
  background-color: #00AE39;
  border: thin solid #00AE39;
  border-radius: 50px;
  overflow: hidden;
  &:hover{
    opacity: 1;
  }
  a{
    border-radius: 50px;
    display: block;
    font-size: 36px;
    color: #fff;

  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

#privacyPolicy{
  position: fixed;
  z-index: 9999;
  bottom: 20px;
  width: 80%;
  border: thin solid #ccc;
  border-radius: 5px;
  left: 10%;
  right: 10%;
  height: 60px;

  .background{
    background-color: #00AE39;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    z-index: 10;
  }

  span{
    position: absolute;
    z-index: 11;
    left: 10px;
    top: 25%;
    text-align: center;
    display: block;
    color: #fff;

    a{
      color: #fff;
      font-weight: bold;
      text-decoration: underline;
    }
  }

  button{
    position: absolute;
    z-index: 11;
    right: 10px;
    top: 10%;
    background-color: #fff;
    color: #000;
    border: none;
    padding: 10px 30px;
    border-radius: 5px;
  }
}

#addToHomescreen{
  position: fixed;
  z-index: 9998;
  bottom: 20px;
  width: 90%;
  display: block;
  background-color: #fff;
  border: thin solid #014687;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;

  span{
    color: #014687;
  }
  img{
    width: 30px;
    padding: 5px;
  }
  b{
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue